import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../config';

export const useBookingDeals = (formData) => {
  const [thursdayDeal, setThursdayDeal] = useState(null);
  const [lunchtimeDeal, setLunchtimeDeal] = useState(null);
  const [firstVisitDeal, setFirstVisitDeal] = useState(null);

  // Auto-check Thursday deal when date/time/therapist change
  useEffect(() => {
    const checkThursdayDeal = async () => {
      if (!formData.date || !formData.time || !formData.therapist_preference) {
        setThursdayDeal(null);
        return;
      }
      try {
        const res = await axios.post(`${API}/promo/check-thursday`, {
          booking_date: formData.date,
          booking_time: formData.time,
          therapist: formData.therapist_preference,
        });
        setThursdayDeal(res.data.eligible ? res.data : null);
      } catch {
        setThursdayDeal(null);
      }
    };
    checkThursdayDeal();
  }, [formData.date, formData.time, formData.therapist_preference]);

  // Auto-check Lunchtime deal when date/time change
  useEffect(() => {
    const checkLunchtimeDeal = async () => {
      if (!formData.date || !formData.time) {
        setLunchtimeDeal(null);
        return;
      }
      try {
        const res = await axios.post(`${API}/promo/check-lunchtime`, {
          booking_date: formData.date,
          booking_time: formData.time,
        });
        setLunchtimeDeal(res.data.eligible ? res.data : null);
      } catch {
        setLunchtimeDeal(null);
      }
    };
    checkLunchtimeDeal();
  }, [formData.date, formData.time]);

  // Auto-check first visit discount when email is entered
  useEffect(() => {
    const checkFirstVisit = async () => {
      const email = formData.client_email?.trim();
      if (!email || !email.includes('@')) {
        setFirstVisitDeal(null);
        return;
      }
      try {
        const res = await axios.post(`${API}/promo/check-first-visit`, { email });
        setFirstVisitDeal(res.data.first_visit ? res.data : null);
      } catch {
        setFirstVisitDeal(null);
      }
    };
    const debounce = setTimeout(checkFirstVisit, 500);
    return () => clearTimeout(debounce);
  }, [formData.client_email]);

  return { thursdayDeal, lunchtimeDeal, firstVisitDeal };
};
